<template>
  <div class="myOrders">
    <topTitle title="我的订单"></topTitle>
    <div class="main">
      <van-tabs v-model="active" @click="selectStatus">
        <van-tab v-for="item in order_status" v-bind:key="item.id" :title="item.name">
          <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              offset="2"
              :immediate-check='false'
              @load="onLoad()"
            >
            <div class="purchase" v-for="(obj,i) in list" :key="i">
              <div class="shopName">
                <p>
                  订单号：{{obj.sn}}
                  <span class="r">{{obj.order_status_text}}</span>
                </p>
              </div>
              <div v-for="(item,index) in obj.sku_list" :key="index">
                <div class="od_cont">
                  <div class="od_cont_img"  @click="toDetails(obj)">
                    <!-- <img :src="item.goods_image" alt /> -->
                    <van-image
                      width="100%"
                      height="100%"
                      fit="cover"
                      :src="item.goods_image" 
                    />
                  </div>
                  <div class="od_cont_xinxi">
                    <h4 class="od_cont_name"  @click="toDetails(obj)">
                      <div class="l">{{item.name}}</div>
                      <div class="r">
                        <p>¥{{item.original_price}}</p>
                        <p class="color-999">重消币:¥{{item.point!=null?item.point:0}}</p>
                      </div>
                    </h4>
                    <h4 class="od_cont_font">
                      <p>数量：x{{item.num}} 
                        <button type="button" class="btn" name="button" @click="qpj(obj,item)"  v-if="obj.order_status == 'ROG' && item.is_commented == '0'">去评价</button>
                      </p>
                      <p class="color-js" v-if="obj.order_status == 'NEW'">请在24小时内支付，如若超时订单自动取消</p>
                    </h4>
                  </div>
                </div>
              </div>
              <div class="money">
                <span>共{{thesum(obj.sku_list)}}件</span>
                <span>
                  合计：
                  <span class="color-yellow">¥{{obj.order_amount}}</span>
                </span>
              </div>
              <div class="dibu" v-if="obj.order_status == 'NEW'">
                <button type="button" name="button" @click="cancelOrders(obj)">取消订单</button>
                <button type="button" name="button" class="on" @click="qzf(obj)">付款</button>
              </div>
              <div class="dibu" v-if="obj.order_status == 'SHIPPED'">
                <button type="button" name="button" @click="towlxq(obj)">查看物流</button>
              </div>
              
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
import { Toast } from 'vant';
export default {
  name: "myOrders",
  data() {
    return {
      active: 0,
      order_status: [
        {
          id: "ALL",
          name: "全部"
        },
        {
          id: "WAIT_PAY",
          name: "待付款"
        },
        {
          id: "WAIT_SHIP",
          name: "待发货"
        },
        {
          id: "WAIT_ROG",
          name: "待收货"
        },
        {
          id: "COMPLETE",
          name: "已完成"
        }
      ],
      list: [],
      loading: false,
      finished: false,
      page_no:1,
      page_size:10,
    };
  },
  components: {
    topTitle
  },
  created(){
    this.active = this.$route.query.type;
    this.getList();
  },
  methods: {
    

    toDetails(obj){
      switch (obj.order_status) {
        case 'NEW'://代付款
          this.payment(obj);
          break;
        case 'PAID_OFF'://待发货
          this.$router.push({path:'pendingDetails', query:{sn:obj.sn,isfh:false,iswc:false}});
          break;
        case 'SHIPPED'://代收货
          this.ckwl(obj);
          break;
        case 'ROG'://已收货
          this.qxq(obj);
          break;
        case 'COMPLETE'://已完成
          this.qxq(obj);
          break;
      }
    },
    qzf(obj){
       localStorage.setItem("isCart", 2);
       localStorage.setItem("sucback", 3);
      console.log(obj)
      this.$router.push({path:'orderPay',query:{
           sn:obj.trade_sn,
           order_price:obj.order_amount,
           type:'1'
			  }});
    },
    qxq(obj){
      this.$router.push({path:'pendingDetails', query:{sn:obj.sn,isfh:true,iswc:true}});
    },
    qpj(obj,item){
      this.$router.push({path:'evaluateOrservice', query:{sn:obj.sn,type:1}});
    },
    ckwl(obj){
      this.$router.push({path:'pendingDetails', query:{sn:obj.sn,isfh:true,iswc:false}});
    },
    payment(obj){
      this.$router.push({path:'pendingPaymentInfo', query:{sn:obj.sn}});
    },
    //物流详情
    towlxq(obj){
      this.$router.push({path:'logisticsInfo', query:{id:obj.logi_id,num:obj.ship_no}});
    },

    cancelOrders(obj){
      this.postRequest( `trade/orders/${obj.sn}/cancel`).then(res => {
        // obj.order_status = 'CANCELLED';
        // this.storeList = this.storeList.filter(obj=>{return !obj.storeshow})
        Toast.success('取消成功');
        this.list = [];
        this.getList();
      })
    },
    onLoad(){
      this.page_no = this.page_no + 1;
      this.getList();
    },
    thesum(arr){
      let num = 0
      arr.forEach(element => {
        num = element.num + num
      });
      return num
    },
    getList(){
      let params = {
        order_status:this.order_status[this.active].id,
        page_no:this.page_no,
        page_size:this.page_size,
        goods_name:''
      }
      this.getRequest( `trade/orders`,params).then(res => {
        if(res.data.code == 1){
          this.list = [];
          this.loading = false;
          this.finished = true;
        }else{
          console.log(res.data.data.data)
          this.list = this.list.concat(res.data.data.data)
          this.loading = false;
          // 数据全部加载完成
          if (res.data.data.data.length < 10) {
            this.finished = true;
          }
        }
      })
    },

    selectStatus: function(key) {
      this.page_no = 1;
      this.list = [];
      this.getList()
    }
  }
};
</script>

<style lang="less" scoped>
.myOrders {
 
  .btn {
    width: 174px;
    height: 60px;
    border: 1px solid #666;
    border-radius: 50px;
    color: #606060;
    font-size: 26px;
    background: #fff;
  }
  .r {
    float: right;
  }
  /deep/.van-tabs {
    background: #fff;
    .van-tabs__wrap {
      width: 100%;
      position: fixed;
      z-index: 100;
      top: 89px;
      left: 0;
    }
    .van-tabs__content {
      padding-top: 89px;
      background: #f8f8f8;
    }
    .van-tab {
      flex-basis: 20% !important;
    }
    .van-tab--active {
      color: #ff1919;
    }
    .van-tab--active .van-tab__text {
      font-size: 30px;
      font-weight: 500;
    }
    .van-tabs__nav .van-tab__text {
      font-size: 28px;
      line-height: 90px;
      font-family: pingFangSC-Medium;
    }
    .van-tabs__nav .van-tabs__line {
      width: 48px !important;
      height: 6px !important;
      background: linear-gradient(to right, #f00f00, #ff9176, #ffddd4);
    }
  }
  .main {
    margin-top: 1px;
    //够买的详情
    .purchase {
      width: 94%;
      margin: 0 auto;
      background-color: white;
      margin-top: 20px;
      overflow: hidden;
      border-radius: 8px;
      .shopName {
        color: #333333;
        font-size: 26px;
        padding: 24px;
        .r {
          color: #ff1919;
          font-size: 26px;
        }
      }
      .od_cont {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 24px;
        overflow: hidden;
        .od_cont_img {
          width: 180px;
          height: 180px;
          overflow: hidden;
          float: left;
          border-radius: 8px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .od_cont_xinxi {
          // width: 460px;
          height: 180px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          float: right;
          overflow: hidden;
          > h4 {
            line-height: 53px;
          }
          .od_cont_name {
            color: #333333;
            // line-height: 30px;
            .l {
              width: 280px;
              height: 90px;
              font-size: 26px;
              line-height: 44px;
              float: left;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .r {
              float:right;
              font-size: 24px;
              p {
                text-align: right;
              }
              line-height: 40px;
            }
          }

          .od_cont_font {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 40px;
            color: rgba(153, 153, 153, 1);
            p{display: flex;justify-content: space-between;align-items: center;}
            .color-js {
              font-size: 24px;
            }
          }
        }
      }
      .border_b {
        height: 1px;
        background: rgba(245, 245, 245, 1);
      }
      .money {
        border-bottom: 1px solid #f5f5f5;
        clear: both;
        line-height: 60px;
        padding-right: 25px;
        font-size: 26px;
        text-align: right;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .color-yellow {
          color: #ff1919;
          font-weight: 600;
        }
        span {
          margin: 0 10px;
        }
        span:last-child {
          margin-right: 0;
        }
      }
      .dibu {
        height: 120px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 24px;
        background-color: #fff;
        button:last-child {
          margin-right: 0;
        }
        button {
          width: 174px;
          height: 60px;
          border: 1px solid #666;
          border-radius: 50px;
          color: #606060;
          margin-right: 24px;
          font-size: 26px;
          background: #fff;
        }
        button.on {
          border: 1px solid #ea3a2b;
          color: #ea3a2b;
          background: linear-gradient(to right, #fd4e1c, #cd1003);
          color: #fff;
        }
      }
    }
  }
}
</style>
